// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nXBM","newExpiryDate":"styles_newExpiryDate__1cEXf","footer":"styles_footer__ZBhvM"};